export const enum SendVerifyCodeAction {
    register = 0,
    resetPassword = 1,
    resetPin = 2,
    emailVerification = 3
  }